// extracted by mini-css-extract-plugin
module.exports = {"SectionHeader":"SectionHeader_SectionHeader__TY39K","action":"SectionHeader_action__mdNec"};